export const getMeterReading = (text, confidence, decimalPlaces) => {
  if (!Number.isFinite(confidence) || confidence < 75) return null;
  if (decimalPlaces !== undefined && ![1, 2].includes(decimalPlaces)) return null;
  const value = String(text || '').replace(/\s/g, '');
  const printed = value.match(/^(\d{4})\.(\d{1,2})$/);
  if (printed) {
    if (decimalPlaces !== undefined && printed[2].length !== decimalPlaces) return null;
    return Number(value).toFixed(printed[2].length);
  }
  const precision = decimalPlaces ?? value.length - 4;
  if (![1, 2].includes(precision) || !new RegExp(`^\\d{${4 + precision}}$`).test(value)) return null;
  return (Number(value) / (10 ** precision)).toFixed(precision);
};

export const advanceMeterReading = value => {
  const decimalPlaces = value.split('.')[1].length;
  return ((Math.round(Number(value) * (10 ** decimalPlaces)) + 1) / (10 ** decimalPlaces)).toFixed(decimalPlaces);
};

export const getMeterWheelDigit = (text, confidence) => {
  if (!Number.isFinite(confidence) || confidence < 75) return null;
  const digits = String(text || '').replace(/\s/g, '');
  if (/^\d$/.test(digits)) return digits;
  if (!/^\d{2}$/.test(digits)) return null;
  const first = Number(digits[0]);
  const second = Number(digits[1]);
  if (first === second) return digits[0];
  if (digits.includes('9') && digits.includes('0')) return '0';
  return Math.abs(first - second) === 1 ? String(Math.max(first, second)) : null;
};

export const getMeterReadingFromWheels = (prefix, prefixConfidence, wheel, wheelConfidence, decimalPlaces) => {
  if (![1, 2].includes(decimalPlaces)) return null;
  const value = String(prefix || '').replace(/\s/g, '');
  if (!new RegExp(`^\\d{4}\\.?\\d{${decimalPlaces - 1}}$`).test(value)) return null;
  const digit = getMeterWheelDigit(wheel, wheelConfidence);
  if (digit === null) return null;
  return getMeterReading(`${value.replace('.', '')}${digit}`, prefixConfidence, decimalPlaces);
};

export const getRollingMeterReading = (value, text, confidence) => {
  const digit = getMeterWheelDigit(text, confidence);
  const current = Number(value.slice(-1));
  const next = String((current + 1) % 10);
  return digit === next ? advanceMeterReading(value) : value;
};

export const nextMeterReading = (previous, value) => {
  if (!value) return { value: null, count: 0 };
  if (previous?.value && previous.value.split('.')[1].length === value.split('.')[1].length) {
    if (advanceMeterReading(previous.value) === value) return { value, count: 1 };
    if (advanceMeterReading(value) === previous.value) return { value: previous.value, count: previous.count + 1 };
  }
  return { value, count: previous?.value === value ? previous.count + 1 : 1 };
};